import { useEffect } from "react";
import { Button, Dialog, H2 } from "@blueprintjs/core";
import SendCode from "./SendCode";
import "./ForgotForm.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentDialogue, setCurrentDialogue } from "controllers/common/action";
import { Analytics } from "utils/analytics";

interface ForgotProps {}
export default function ForgotForm(props: ForgotProps) {
  const dispatch = useDispatch();
  const currentDialogue = useSelector(selectCurrentDialogue);
  const shouldOpen = currentDialogue === "Forgot";

  useEffect(() => {
    if (shouldOpen) {
      Analytics.getInstance().event("Forgot Password", "Opened");
    }
    return () => {};
  }, [shouldOpen]);

  const handleLogin = () => dispatch(setCurrentDialogue("Login"));
  const shouldClose = () => dispatch(setCurrentDialogue(""));

  return (
    <Dialog className="forgot" isOpen={shouldOpen}>
      <div className="form__header">
        <Button icon="arrow-left" minimal intent="primary" onClick={handleLogin} text="Back to Log In" />
        <Button minimal intent="primary" icon="cross" onClick={shouldClose} />
      </div>
      <H2>Forgot Password</H2>
      <SendCode />
    </Dialog>
  );
}
